<div class="import-tabular-table-container">
    <div *ngIf="validationData | async as validationDataValue">
        <app-table-with-sections [currentTab]="'zones'" [type]="tableType" [uploadZoningCode]="false" [zoningCode]="validationDataValue"
            [hideAttributeButtons]="true" [readOnly]="true" [validateHeaderFields]="true"></app-table-with-sections>
    </div>
</div>

<app-import-footer [templateType]="templateType" [showValidationIcon]="!!(validationData | async)" [canImport]="canImport"
    [showValidateButton]="showValidateButton" (uploadFile)="openDialog()" (importData)="importData()"
    (validateZoningCode)="validateZC()" (clearTable)="clearTable()"></app-import-footer>
